<div class="col-sm-12 fiche_Contact" style="height: 100%; padding-top: 5px;">
  <div class="fiche">
    <div class="text-right col-sm-12 pull-right" style="padding-right: 0;">
      <div class="col-sm-6 fiche-client">
        <div *ngIf="!add" class="numchantier"> {{ contact.nom }} {{ contact.prenom || '' }} </div>
        <div *ngIf="add"> Création Contact </div>
      </div>
      <button class="uppercase" *ngIf="edit && !add" id="savecont" (click)="saveContact()"> Enregistrer </button>
      <button class="uppercase" *ngIf="add" id="addcont" (click)="saveContact()"> Valider </button>
      <button class="uppercase" *ngIf="!edit" id="editcont" (click)="editContact()">Modifier </button>
      <button class="uppercase btn-close" id="closecont" (click)="showFiche()"> Fermer </button>
    </div>

    <div class="col-sm-12" style="padding-right: 0;" [ngStyle]="{'padding-top': '5px'}">
      <div class="input-group col-sm-12 recherche">
        <input  type="text" id="ficheinput2" class="form-control" placeholder="Rechercher une donnée contact"
          [(ngModel)]="searchCritere" (keyup.enter)="filtreSearch($event)" (ngModelChange)="changeRecherche()" />
        <div class="input-group-addon">
          <img src="assets/images/icons/search.svg" class="pull-right" alt="search" />
        </div>
      </div>
    </div>
  </div>
  <div class="contente" *ngIf="!isEmpty">
    <div class="info-client cht col-sm-12 pull-right">
      <div class="col-sm-12" *ngIf="isRecherche" style="background-color: #dbe8f8; padding: 5px 20px; letter-spacing: 2px;">
        Résultat de la recherche </div>
      <div class="col-sm-12 searchblock">
        <div *ngIf="add" style="font-size: 10px;"> ( <span style="color:red;">*</span> ) : Champs obligatoires </div>
        <div class="group1">
          <h4 style="margin-top: 0;" *ngIf="!hidetitle"> Général </h4>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px">Civilité :</label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit">{{ contact.civilite }}</div>
              <div *ngIf="edit">
                <app-autocomplete (selectfunction)="contact.civilite = $event" [results]="listCivilite" [highlight]="true"
                  [id]="'modedepaie'" [isCombo]="true" [defaultselected]="contact.civilite" [defaultsearch]="contact.civilite ? contact.civilite.libelleObjetEntite : ''"></app-autocomplete>
              </div>
            </div>
          </div>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px"> Nom :
            </label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit">{{ contact.nom || ''}}</div>
              <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contact.nom">
            </div>
          </div>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px"> Prénom :</label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit"> {{ contact.prenom }} </div>
              <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contact.prenom">
            </div>
          </div>

          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px">Tel :</label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit"> {{contact.tel}} </div>
              <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contact.tel">
            </div>
          </div>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px"> Fax :</label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit">{{ contact.fax }}</div>
              <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contact.fax">
            </div>
          </div>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px"> Portable :</label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit">{{ contact.portable }}</div>
              <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contact.portable">
            </div>
          </div>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px"> Mail :</label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit">{{ contact.mail }}</div>
              <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contact.mail">
            </div>
          </div>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px"> Fonction :</label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit">{{ contact.fonction }}</div>
              <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contact.fonction">
            </div>
          </div>

          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px">
              Adresse
              <span class="champobligatoire" *ngIf="add"> * </span>
            </label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit">{{ contact.adresse1 }}</div>
              <div *ngIf="!edit">{{ contact.adresse2 }}</div>
              <div *ngIf="!edit">{{ contact.adresse3 }}</div>
              <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contact.adresse1">
              <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contact.adresse2" style="margin-top: 5px; margin-bottom: 5px;">
              <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contact.adresse3">
            </div>
          </div>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px">
              CP :
            </label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit"> {{contact.CP}} </div>
              <div *ngIf="edit">
                <app-autocomplete-cp-ville [cp]="'CP'" [item]="contact" [ville]="'ville'" [iscp]="true"></app-autocomplete-cp-ville>
              </div>
            </div>
          </div>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px">
              Ville :
              <!-- <span class="champobligatoire" *ngIf="add"> * </span> -->
            </label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit"> {{contact.ville}} </div>
              <div *ngIf="edit">
                <app-autocomplete-cp-ville [cp]="'CP'" [item]="contact" [ville]="'ville'"></app-autocomplete-cp-ville>
              </div>
            </div>
          </div>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px"> Commercial : </label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit"> {{ contact.commercial ? contact.commercial.libelleObjetEntite : '' }} </div>
              <div *ngIf="edit">
                <app-autocomplete (selectfunction)="contact.commercial = $event" [results]="listComm" [highlight]="true"
                  [id]="'modedepaie'" [isCombo]="true" [defaultselected]="contact.commercial" [defaultsearch]="contact.commercial ? contact.commercial.libelleObjetEntite : ''"></app-autocomplete>
              </div>
            </div>
          </div>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px"> Chantier : </label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit"> {{ contact.chantier ? contact.chantier.libelleObjetEntite : '' }} </div>
              <div *ngIf="edit">
                <app-autocomplete (selectfunction)="contact.chantier = $event" [results]="listChantier" [highlight]="true"
                  [id]="'modedepaie'" [isCombo]="true" [defaultselected]="contact.chantier" [defaultsearch]="contact.chantier ? contact.chantier.libelleObjetEntite : ''"></app-autocomplete>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>